/** @file sameTile: whether two TileRefs name the same tile (drawable, entry and tile index). */
import type { TileRef } from './editorTypes';

/** True when both refs name the same tile. */
export const sameTile = (a: TileRef, b: TileRef): boolean => a.drawable === b.drawable && a.entry === b.entry && a.tile === b.tile;
